import script from "/home/l/dev/unolet/unolet/frontend/src/ts/vue/components/ListPagination.vue?type=script"
export * from "/home/l/dev/unolet/unolet/frontend/src/ts/vue/components/ListPagination.vue?type=script"

import "/home/l/dev/unolet/unolet/frontend/src/ts/vue/components/ListPagination.vue?type=style&index=0"
export default script
script.__scopeId = "data-v-5f579f24"